import React, { FunctionComponent } from 'react'
import { Heading, Paragraph, majorScale, TextInputField } from 'evergreen-ui'
import DialogLayout from './DialogLayout'

interface DisableStepProps {
  onBack: () => void
  onDisable: () => void
  onPasswordChange: (password: string) => void
  password: string
  mfaName: string
}

const DisableStep: FunctionComponent<DisableStepProps> = props => {
  const { onBack, onDisable, onPasswordChange, password, mfaName } = props

  return (
    <DialogLayout onBackClick={onBack} onConfirmClick={onDisable} confirmLabel="Disable" confirmIntent="danger">
      <Heading size={600} marginBottom={majorScale(3)} textAlign="center">
        Disable {mfaName} Multi-Factor Authentication
      </Heading>

      <Paragraph marginBottom={majorScale(2)}>
        Disabling {mfaName} Multi-Factor Authentication will no longer require you to enter a security code to sign in.
        Disabling this will erase these configured settings.
      </Paragraph>

      <Paragraph marginBottom={majorScale(2)}>
        Please enter your password to disable {mfaName} Multi-Factor Authentication.
      </Paragraph>

      <TextInputField
        type="password"
        autoComplete="current-password"
        autoFocus
        required
        label="Password"
        placeholder="Enter your password"
        value={password}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onPasswordChange(e.target.value)}
        marginBottom="0"
      />
    </DialogLayout>
  )
}

export default DisableStep
